import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../caq-request/caq-request.service';
import { DespesaCapitalDto } from '../../dtos/despesa-capital-dto';

@Injectable({
  providedIn: 'root',
})
export class DespesaCapitalService {
  private apiUrl = `${environment.apiUrl}/despesa-capital`;

  constructor(private caqRequestService: CaqRequestService) {}

  calcularPlanoPorMunicipio(
    idMunicipio: number,
  ): Observable<DespesaCapitalDto> {
    return this.caqRequestService
      .get<any>(`${this.apiUrl}/municipio/plano/${idMunicipio}`)
      .pipe(map((response) => this.mapResponse(response)));
  }

  calcularRedePorMunicipio(idMunicipio: number): Observable<DespesaCapitalDto> {
    return this.caqRequestService
      .get<any>(`${this.apiUrl}/municipio/rede/${idMunicipio}`)
      .pipe(map((response) => this.mapResponse(response)));
  }

  porPlanoEstadual(idEstado: number): Observable<DespesaCapitalDto> {
    return this.caqRequestService
      .get<any>(`${this.apiUrl}/estado/plano/${idEstado}`)
      .pipe(map((response) => this.mapResponse(response)));
  }

  porRedeEstadual(idEstado: number): Observable<DespesaCapitalDto> {
    return this.caqRequestService
      .get<any>(`${this.apiUrl}/estado/rede/${idEstado}`)
      .pipe(map((response) => this.mapResponse(response)));
  }

  porAno(): Observable<DespesaCapitalDto> {
    return this.caqRequestService
      .get<any>(`${this.apiUrl}`)
      .pipe(map((response) => this.mapResponse(response)));
  }

  private mapResponse(response: any): DespesaCapitalDto {
    if (!response || (Array.isArray(response) && response.length === 0)) {
      return response as any;
    }

    return {
      totalGeral:
        response.totalGeral ??
        (typeof response.totalGeral === 'number' ? response.totalGeral : 0),
      ampliacaoRedeFisica: {
        valor:
          response.ampliacaoRedeFisica?.valor ??
          (typeof response.ampliacaoRedeFisica === 'number'
            ? response.ampliacaoRedeFisica
            : 0),
        percentual:
          response.ampliacaoRedeFisica?.percentual ??
          response.percAmpliacaoRedeFisica ??
          0,
      },
      ampliacaoRedeFisicaEducacaoInfantil: {
        valor:
          response.ampliacaoRedeFisicaEducacaoInfantil?.valor ??
          (typeof response.educacaoInfantil === 'number'
            ? response.educacaoInfantil
            : 0),
        percentual:
          response.ampliacaoRedeFisicaEducacaoInfantil?.percentual ??
          response.percEducacaoInfantil ??
          0,
      },
      ampliacaoRedeFisicaEnsinoFundamental: {
        valor:
          response.ampliacaoRedeFisicaEnsinoFundamental?.valor ??
          (typeof response.escolasFundamentalMedioEja === 'number'
            ? response.escolasFundamentalMedioEja
            : 0),
        percentual:
          response.ampliacaoRedeFisicaEnsinoFundamental?.percentual ??
          response.percEscolasFundamentalMedioEja ??
          0,
      },
      ampliacaoDependencias: {
        valor:
          response.ampliacaoDependencias?.valor ??
          (typeof response.ampliacaoDependenciasUnidadesExistentes === 'number'
            ? response.ampliacaoDependenciasUnidadesExistentes
            : 0),
        percentual:
          response.ampliacaoDependencias?.percentual ??
          response.percAmpliacaoDependenciasUnidadesExistentes ??
          0,
      },
    };
  }
}
